import { useRouter } from 'next/router'

import HelpCenterSearchFeature from 'app/features/HelpCenter/HelpCenterSearchFeature'

import HeroSection from './components/HeroSection'

const HelpCenterSearchView = () => {
  const { query } = useRouter()
  const keyword = (query?.keyword ?? '') as string

  return (
    <>
      <HeroSection />

      <HelpCenterSearchFeature keyword={keyword} />
    </>
  )
}

export default HelpCenterSearchView
